import React from "react";

// Eyebrow + section title + ornamental rule. Used between Home sections.
export default function SectionRule({ eyebrow, title, lede, align = "left" }) {
  const alignCls = align === "center" ? "text-center" : "text-left";
  return (
    <div
      className={`max-w-3xl ${align === "center" ? "mx-auto" : ""} ${alignCls} mb-10 md:mb-14`}
    >
      {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
      <h2 className="font-display text-3xl md:text-5xl text-ink leading-[1.1] tracking-tightish">
        {title}
      </h2>
      {lede && (
        <p className="font-serif text-lg md:text-xl text-ink-soft mt-4 leading-relaxed">
          {lede}
        </p>
      )}
    </div>
  );
}
